import axios from "axios";
import { useInfiniteQuery } from "@tanstack/react-query";

import { Keys } from "../_keys";
import { Routes } from "../_routes";

export const useGetCorps = () =>
  useInfiniteQuery({
    queryKey: [Keys.CORPS],

    queryFn: async ({ pageParam }) =>
      axios.get(Routes.GET_CORPS + `?page=${pageParam ?? 1}`),

    getNextPageParam: ({ data }) => {
      const res = data?.data?.items;
      return res?.next_page_url ? res?.current_page + 1 : null;
    },
    getPreviousPageParam: ({ data }) => {
      const res = data?.data?.items;
      return res?.prev_page_url ? res?.current_page - 1 : null;
    },
    cacheTime: 0,
  });
